var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0356 7.43516C8.5997 7.43516 7.43564 8.59922 7.43564 10.0352V13.7494C7.43564 15.1854 8.5997 16.3494 10.0356 16.3494H13.7499C15.1859 16.3494 16.3499 15.1854 16.3499 13.7494V10.0352C16.3499 8.59922 15.1859 7.43516 13.7499 7.43516H10.0356Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85 4.75C2.85 3.70066 3.70066 2.85 4.75 2.85H9.39286C10.4422 2.85 11.2929 3.70066 11.2929 4.75V9.39286C11.2929 10.4422 10.4422 11.2929 9.39286 11.2929H4.75C3.70066 11.2929 2.85 10.4422 2.85 9.39286V4.75Z",
    stroke: "#000000",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconBlack);
export default __webpack_public_path__ + "static/media/copy-icon-black.ede3f3353a282aeaec3791dc766cbdc5.svg";
export { ForwardRef as ReactComponent };